/**
 * src/pages/venue/VenueSearchPage.tsx — 2004va
 *
 * STUB — full implementation in a later commit.
 * Search is the SECONDARY tool by design, not the hero.
 */

import type { Venue } from '@/types'
import type { PickerSession } from '@/lib/venue'

interface Props { venue: Venue; picker: PickerSession }

export function VenueSearchPage(_props: Props) {
  return (
    <div className="bg-room-surface border border-room-border rounded-2xl p-5">
      <p className="text-xs uppercase tracking-widest text-room-muted font-semibold mb-2">
        Search
      </p>
      <p className="text-sm text-white">
        Stub — search interface to be implemented.
      </p>
    </div>
  )
}
